import axios from 'axios';
import _ from 'lodash';
import { CUSTOMERS_FILE_TYPE, fullURL, parseAxiosError } from '../utils';

const UPLOADED_FILES_SET = 'UPLOADED_FILES_SET';
const UPLOADED_FILES_ADD = 'UPLOADED_FILES_ADD';
const UPLOADED_FILES_REMOVE = 'UPLOADED_FILES_REMOVE';
const UPLOADED_FILE_FETCH = 'UPLOADED_FILE_FETCH';
const UPLOADED_FILE_DELETE = 'UPLOADED_FILE_DELETE';

const UPDATE_FILE_ENTITY_MAP = 'UPDATE_FILE_ENTITY_MAP';
const SAVE_FILE_ENTITY_MAP = 'SAVE_FILE_ENTITY_MAP';

const CREATED_PROJECTS_SET = 'CREATED_PROJECTS_SET';
const CREATED_PROJECTS_ADD = 'CREATED_PROJECTS_ADD';
const UPDATE_EXISTING_PROJECT = 'UPDATE_EXISTING_PROJECT';
const UPDATE_FILE_TYPE = 'UPDATE_FILE_TYPE';
const SAVE_PROJECT = 'SAVE_PROJECT';
const UPDATE_PROJECT = 'UPDATE_PROJECT';
const DELETE_PROJECT = 'DELETE_PROJECT';
const REMOVE_PROJECT = 'REMOVE_PROJECT';
const ACTIVE_PROJECT_FETCH = 'ACTIVE_PROJECT_FETCH';
const ACTIVE_PROJECT_SET = 'ACTIVE_PROJECT_SET';
const ACTIVE_PROJECT_UPDATE = 'ACTIVE_PROJECT_UPDATE';
const UPDATE_PROJECT_TYPE_FILE = 'UPDATE_PROJECT_TYPE_FILE';
const REFRESH_PROJECTS = 'REFRESH_PROJECTS';
const UPDATE_PROJECT_FILE_ENTITY_MAP = 'UPDATE_PROJECT_FILE_ENTITY_MAP';
const SAVE_PROJECT_FILE_ENTITY_MAP = 'SAVE_PROJECT_FILE_ENTITY_MAP';

const ACTIVE_FILES_UPDATE = 'ACTIVE_FILES_UPDATE';
const ACTIVE_FILES_SAVE = 'ACTIVE_FILES_SAVE';
const COLLECTIONS = 'COLLECTIONS';
const KEY_INSIGHT_IDS = 'KEY_INSIGHT_IDS';
const DASHBOARDS = 'DASHBOARDS';
const PROJECT_DASHBOARDS = 'PROJECT_DASHBOARDS';
const TABLE_DASHBOARDS = 'TABLE_DASHBOARDS';
const TARGETS = 'TARGETS';

const INIT_FILES = 'INIT_FILES';

const _setActiveFiles = mapping => ({
    type: ACTIVE_FILES_UPDATE,
    mapping
});

const _setActiveProject = project => ({
    type: ACTIVE_PROJECT_SET,
    project
});

const _setUploadedFiles = files => ({
    type: UPLOADED_FILES_SET,
    files
});

const _setCreatedProjects = projects => ({
    type: CREATED_PROJECTS_SET,
    projects
});

const _addCreatedProject = project => ({
    type: CREATED_PROJECTS_ADD,
    project
});

const _updateProject = (projectID, name, description) => ({
    type: UPDATE_EXISTING_PROJECT,
    projectID,
    name,
    description
});

const _removeProject = projectID => ({
    type: REMOVE_PROJECT,
    projectID
});

const _addUploadedFile = file => ({
    type: UPLOADED_FILES_ADD,
    file
});

const _removeUploadedFile = fileID => ({
    type: UPLOADED_FILES_REMOVE,
    fileID
});


export const _updateFileEntityMapChange = (fileID, entityMap) => ({
    type: UPDATE_FILE_ENTITY_MAP,
    fileID,
    entityMap
});

export const _updateProjectFileEntityMapChange = (projectID, fieldMap) => ({
    type: UPDATE_PROJECT_FILE_ENTITY_MAP,
    projectID,
    fieldMap
});

export const saveActiveFilesChanges = mapping => ({
    type: ACTIVE_FILES_SAVE,
    mapping
});

export const fetchUploadedFile = fileID => ({
    type: UPLOADED_FILE_FETCH,
    fileID
});

export const fetchActiveProject = () => ({ type: ACTIVE_PROJECT_FETCH });

export const deleteUploadedFile = fileID => ({
    type: UPLOADED_FILE_DELETE,
    fileID
});

export const saveFileEntityMapChange = (fileID, entityMap) => ({
    type: SAVE_FILE_ENTITY_MAP,
    fileID,
    entityMap
});

export const saveProjectFileEntityMapChange = (projectID, fieldMap) => ({
    type: SAVE_PROJECT_FILE_ENTITY_MAP,
    projectID,
    fieldMap
});

export const updateFileType = (fileID, fileType) => ({
    type: UPDATE_FILE_TYPE,
    fileID,
    fileType
});

export const saveProject = (name, description) => ({
    type: SAVE_PROJECT,
    name,
    description
});

export const updateProject = (projectID, name, description) => ({
    type: UPDATE_PROJECT,
    projectID,
    name,
    description
});

export const deleteProject = (projectID) => ({
    type: DELETE_PROJECT,
    projectID
});

export const updateActiveProject = (project) => ({
    type: ACTIVE_PROJECT_UPDATE,
    project
});

export const updateProjectFiles = (projectID, fileType, fileID) => ({
    type: UPDATE_PROJECT_TYPE_FILE,
    projectID,
    fileType,
    fileID
});

export const refreshProjects = () => ({ type: REFRESH_PROJECTS });

export const initFiles = () => ({ type: INIT_FILES });

export default {
    state: {
        fileList: [],
        projectList: [],
        projectDashboards: [],
        activeMap: {},
        activeProject: {},
        collections: [],
        keyInsightIds: [],
        dashboards: [],
        tableDashboards: [],
        targetList: [],
        allInsights: []
    },

    getters: {
        getActiveFile: ({ activeMap }, { getFile }) =>
            type => getFile(activeMap[type]),

        getActiveProject: ({ activeProject }) => {
            return activeProject;
        },

        getFile: ({ fileList }) =>
            fileID =>
            fileList.find(({ id }) => fileID === id),

        fileColumns: (state, { getFile }) =>
            (fileType, visibleOnly) => {
                const file = getFile(fileType);
                return file ? file.columns : [];
            },

        customerFileColumns: (state, { fileColumns }) =>
            (visibleOnly = false) =>
            fileColumns(CUSTOMERS_FILE_TYPE, visibleOnly),

        customerCount: (state, { getActiveFile }) => {
            const file = getActiveFile(CUSTOMERS_FILE_TYPE);
            return file ? file.rowCount : 1;
        },

        // getProjectFile: ({fileList}) =>
        //   type => getFile(project[type]),

        getProject: ({ projectList }) =>
            projectID =>
            projectList.find(({ id }) => projectID === id),
    },

    mutations: {
        [UPLOADED_FILES_SET](state, { files }) {
            state.fileList = files;
        },

        [CREATED_PROJECTS_SET](state, { projects }) {
            state.projectList = projects;
        },

        [COLLECTIONS](state, collections) {
            state.collections = collections;
        },

        [KEY_INSIGHT_IDS](state, keyInsightIds) {
            state.keyInsightIds = keyInsightIds;
        },

        [DASHBOARDS](state, dashboards) {
            state.dashboards = dashboards;
        },

        [PROJECT_DASHBOARDS](state, projectDashboards) {
            state.projectDashboards = projectDashboards;
        },

        [TABLE_DASHBOARDS](state, tableDashboards) {
            state.tableDashboards = tableDashboards;
        },

        [TARGETS](state, targetList) {
            state.targetList = targetList;
        },

        [UPLOADED_FILES_ADD](state, { file }) {
            const files = state.fileList.filter(f => f.id !== file.id);
            state.fileList = [...files, file];
        },

        [CREATED_PROJECTS_ADD](state, { project }) {
            const projects = state.projectList.filter(f => project.id !== project.id);
            // state.projectList = [...projects, project];
            state.projectList.push(project);
        },

        [UPDATE_EXISTING_PROJECT](state, { projectID, name, description }) {
            for (var i = 0; i < state.projectList.length; i++) {
                if (state.projectList[i].id === projectID) {
                    state.projectList[i].name = name;
                    state.projectList[i].description = description;
                }
            }
        },

        [UPLOADED_FILES_REMOVE](state, { fileID }) {
            state.activeMap = ((map) => {
                Object.keys(map)
                    .forEach(key => {
                        if (map[key] === fileID) {
                            delete map[key];
                        }
                    });
                return {...map };
            })(state.activeMap);

            state.fileList = state.fileList.filter(({ id }) => id !== fileID);
        },

        [REMOVE_PROJECT](state, { projectID }) {
            for (var i = 0; i < state.projectList.length; i++) {
                if (state.projectList[i].id === projectID) {
                    delete state.projectList[i];
                    // state.activeProject = state.projectList[0];
                }
            }

            // state.projectList = state.projectList.filter(({ id }) => id !== projectList);
        },

        [ACTIVE_FILES_UPDATE](state, { mapping }) {
            state.activeMap = {...state.activeMap, ...mapping };
        },

        [ACTIVE_PROJECT_SET](state, { project }) {
            state.activeProject = project;
        },

        [ACTIVE_PROJECT_UPDATE](state, { project }) {
            console.log("P3: ", project);
            state.activeProject = project;
        },

        [UPDATE_FILE_ENTITY_MAP](state, { fileID, entityMap }) {
            state.fileList = state.fileList.map(
                file => file.id === fileID ? {...file, entityMap } : file);
        },

        [UPDATE_PROJECT_FILE_ENTITY_MAP](state, { projectID, fieldMap }) {
            state.projectList = state.projectList.map(
                project => project.id === projectID ? {...project, fieldMap } : project);
        },

        [UPDATE_FILE_TYPE](state, { fileID, type }) {
            state.fileList = state.fileList.map(
                file => file.id === fileID ? {...file, type } : file);
        },

        [UPDATE_PROJECT_TYPE_FILE](state, { projectID, fileType, fileID }) {
            var projects = state.projectList;
            var p = null;
            projects.forEach(project => {
                if (project.id === projectID) {
                    project.files = !!project.files ? project.files : {};
                    project.files[fileType] = fileID;
                    p = project;
                }
            });
            for (var i = 0; i < state.projectList.length; i++) {
                if (state.projectList[i].id == projectID) {
                    state.projectList[i] = p;
                }
            }
        }
    },

    actions: {
        [INIT_FILES]({ commit, dispatch }) {
            return new Promise((resolve, reject) => {
                // const endpoints = ['/file/all', '/project/all', '/file/active', '/project/active', '/file/collections', '/custom-reports/key-insights/ids', '/dashboards/all'].map(e => axios.get(fullURL(e)));
                const endpoints = ['/file/all', '/project/all', '/file/active', '/project/active', '/file/collections', '/custom-reports/key-insights/ids', '/dashboards/all?exclusion_type=table', '/dashboards/all?report_type=table', '/dashboards/target/all'].map(e => axios.get(fullURL(e)));

                axios.all(endpoints)
                    .then(axios.spread(({ data: files }, { data: projects }, { data: activeMap }, { data: activeProjectData }, { data: collections }, { data: keyInsightIds }, { data: dashboards }, { data: tableDashboards }, { data: targetList }) => {
                        Object.keys(activeMap).forEach(type => {
                            const fileID = activeMap[type];
                            if (!fileID || files.findIndex(file => file.id === fileID) < 0)
                                delete activeMap[type];
                        });
                        commit(COLLECTIONS, collections);
                        commit(KEY_INSIGHT_IDS, keyInsightIds);
                        commit(DASHBOARDS, dashboards);
                        commit(TABLE_DASHBOARDS, tableDashboards);
                        commit(TARGETS, targetList);

                        commit(_setUploadedFiles(files));
                        commit(_setCreatedProjects(projects));
                        commit(_setActiveFiles(activeMap));
                        commit(_setActiveProject(activeProjectData['project']));
                        var projectDashboards = [];
                        projects.forEach(project => {
                            if (!!project['files']) {
                                let projectFiles = project['files'];
                                Object.keys(projectFiles).forEach(fileType => {
                                    axios.get(
                                        fullURL('/project/' + project.id + '/' + fileType + '/' +
                                            projectFiles[fileType])
                                    ).then(({ data }) => {
                                        // console.log("Project Dashboard: ", data);
                                        data['project_id'] = project.id;
                                        projectDashboards.push(data);
                                    })
                                });
                            }
                        });
                        commit(PROJECT_DASHBOARDS, projectDashboards);

                        const missingInMap = {};
                        files.forEach(({ type, id }) => {
                            if (!activeMap.hasOwnProperty(type)) {
                                missingInMap[type] = id;
                            }
                        });

                        if (!_.isEmpty(missingInMap)) {
                            dispatch(saveActiveFilesChanges(missingInMap))
                                .then(resolve)
                                .catch(e => reject(parseAxiosError(e)));
                        } else {
                            resolve();
                        }
                    }))
                    .catch(e => reject(parseAxiosError(e)));
            });
        },

        [ACTIVE_FILES_SAVE]({ commit, state: { activeMap } }, { mapping }) {
            mapping = {...activeMap, ...mapping };

            return new Promise((resolve, reject) => {
                axios.post(fullURL('/file/active'), { mapping })
                    .then(() => {
                        commit(_setActiveFiles(mapping));
                        resolve();
                    })
                    .catch(e => reject(parseAxiosError(e)));
            });
        },

        async [UPLOADED_FILE_FETCH]({ commit, dispatch }, { fileID }) {
            const { data: file } = await axios.get(fullURL(`/file/${fileID}`));
            commit(_addUploadedFile(file));
        },

        async [REFRESH_PROJECTS]({ commit, dispatch }, {}) {
            return new Promise((resolve, reject) => {
                const endpoints = ['/file/all', '/project/all'].map(e => axios.get(fullURL(e)));

                axios.all(endpoints)
                    .then(axios.spread(({ data: files }, { data: projects }) => {
                        console.log("Refreshed Files: ", files);
                        console.log("Refreshed Projects: ", projects);
                        commit(_setUploadedFiles(files));
                        commit(_setCreatedProjects(projects));
                    }))
                    .catch(e => reject(parseAxiosError(e)));
            });
        },

        async [ACTIVE_PROJECT_FETCH]({ commit, dispatch }, {}) {
            const { data: project } = await axios.get(fullURL(`/project/active`));
            commit(_setActiveProject(project['project']));
        },

        async [ACTIVE_PROJECT_UPDATE]({ commit, state: { activeProject } }, { project }) {
            activeProject = project;
            console.log("P2: ", activeProject, project);
            const data = { projectID: project['id'] };
            await axios.post(fullURL(`/project/active`), data);
            commit(_setActiveProject(project));
        },

        async [UPLOADED_FILE_DELETE]({ commit, state: { activeMap }, dispatch }, { fileID }) {
            await axios.delete(fullURL(`/file/${fileID}`));

            const isActiveFile =
                Object.values(activeMap)
                .includes(fileID);

            if (isActiveFile) {
                const newMapping =
                    Object
                    .keys(activeMap)
                    .reduce((map, type) => ({
                        ...map,
                        [type]: activeMap[type] === fileID ? "" : activeMap[type]
                    }), {});
                await dispatch(saveActiveFilesChanges(newMapping));
            }

            commit(_removeUploadedFile(fileID));
        },

        async [SAVE_FILE_ENTITY_MAP]({ commit, state: { fileList } }, { fileID, entityMap }) {
            const data = { entityMap, fileID };
            await axios.post(fullURL('/file/entity_map'), data);
            commit(_updateFileEntityMapChange(fileID, entityMap));
        },

        async [SAVE_PROJECT_FILE_ENTITY_MAP]({ commit, state: { projectList } }, { projectID, fieldMap }) {
            const data = { fieldMap, projectID };
            await axios.post(fullURL('/project/' + projectID + '/entity_map'), data);
            commit(_updateProjectFileEntityMapChange(projectID, fieldMap));
        },

        async [SAVE_PROJECT]({ commit, state: { projectList } }, { name, description }) {
            const data = { name, description };
            const { data: project } = await axios.post(fullURL('/project'), data);
            commit(_addCreatedProject(project));
            commit(_setActiveProject(project));
        },

        async [UPDATE_PROJECT]({ commit, state: { projectList } }, { projectID, name, description }) {
            const data = { name, description };
            await axios.put(fullURL('/project/' + projectID), data);
            commit(_updateProject(projectID, name, description));
        },

        async [DELETE_PROJECT]({ commit, state: { projectList } }, { projectID }) {
            const data = {};
            await axios.delete(fullURL('/project/' + projectID), data);
            commit(_removeProject(projectID));
        },

        async [UPDATE_FILE_TYPE]({ commit, state: { fileList } }, { fileID, fileType }) {
            let data = { fileType, fileID };
            data['type'] = fileType;
            console.log("Data: ", data);
            await axios.put(fullURL('/file/type'), data);
            commit(updateFileType(fileID, fileType));
        },

        async [UPDATE_PROJECT_TYPE_FILE]({ commit, state: { projectList } }, { projectID, fileID, fileType }) {
            let data = { fileType, fileID };
            data['type'] = fileType;
            data['fileID'] = fileID;
            console.log("Data: ", data);
            await axios.post(fullURL('/project/' + projectID + '/file'), data);
            commit(updateProjectFiles(projectID, fileType, fileID));
        }
    }
};